// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file CoordPoint.proto (package CoordPoint, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file CoordPoint.proto.
 */
export const file_CoordPoint: GenFile = /*@__PURE__*/
  fileDesc("ChBDb29yZFBvaW50LnByb3RvEgpDb29yZFBvaW50ItgFCgpDb29yZFBvaW50EisKBXd0eXBlGAEgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi0KCGNvbmZpZ0lkGAIgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSMgoMY29vcmRwb2ludGlkGAMgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEicKAmlkGAQgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLgoIbGF0aXR1ZGUYBSABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWUSLwoJbG9uZ2l0dWRlGAYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEjEKC21heGFsdGl0dWRlGAcgASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEjEKC21pbmFsdGl0dWRlGAggASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEioKBG5hbWUYCSABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSNQoPbm9taW5hbGFsdGl0dWRlGAogASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEi0KCW5vdHVwZGF0ZRgLIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWUSLgoJcHJvamVjdElkGAwgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSKgoEdHlwZRgNIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIrCgd1cGRhdGVkGA4gASgLMhouZ29vZ2xlLnByb3RvYnVmLkJvb2xWYWx1ZRIvCgt1c2VyZGVmaW5lZBgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWVCQAotY29tLmdtdi5kZW1ldGVyLm5hdmFpZHMubW9kZWwucHJvdG8uZ2VuZXJhdGVkQg9Db29yZFBvaW50UHJvdG9iBnByb3RvMw", [file_google_protobuf_wrappers]);

/**
 * @generated from message CoordPoint.CoordPoint
 */
export type CoordPoint = Message<"CoordPoint.CoordPoint"> & {
  /**
   * @generated from field: google.protobuf.StringValue wtype = 1;
   */
  wtype?: string;

  /**
   * @generated from field: google.protobuf.Int32Value configId = 2;
   */
  configId?: number;

  /**
   * @generated from field: google.protobuf.StringValue coordpointid = 3;
   */
  coordpointid?: string;

  /**
   * @generated from field: google.protobuf.Int32Value id = 4;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue latitude = 5;
   */
  latitude?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue longitude = 6;
   */
  longitude?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue maxaltitude = 7;
   */
  maxaltitude?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue minaltitude = 8;
   */
  minaltitude?: number;

  /**
   * @generated from field: google.protobuf.StringValue name = 9;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue nominalaltitude = 10;
   */
  nominalaltitude?: number;

  /**
   * @generated from field: google.protobuf.BoolValue notupdate = 11;
   */
  notupdate?: boolean;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 12;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.StringValue type = 13;
   */
  type?: string;

  /**
   * @generated from field: google.protobuf.BoolValue updated = 14;
   */
  updated?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue userdefined = 15;
   */
  userdefined?: boolean;
};

/**
 * Describes the message CoordPoint.CoordPoint.
 * Use `create(CoordPointSchema)` to create a new message.
 */
export const CoordPointSchema: GenMessage<CoordPoint> = /*@__PURE__*/
  messageDesc(file_CoordPoint, 0);

